// extracted by mini-css-extract-plugin
export default {"container":"OkFNHmveI5_product-carousel"};